import { useMemo } from 'react';

const GLOBAL_MODIFICATION_GROUP_PERCENTAGE_COLUMN_PATH = 'percentage';
const LINE_ITEMS_CHARGES_PERCENTAGE_PATTERN = /^modification_groups\[0\]\.(\*\.)?charges\.(\*|\[\d+\])\.percentage$/;
const LINE_ITEMS_ALLOWANCES_PERCENTAGE_PATTERN =
  /^modification_groups\[0\]\.(\*\.)?allowances\.(\*|\[\d+\])\.percentage$/;

const shouldRemoveField = (fullPath: string): boolean => {
  return (
    fullPath === GLOBAL_MODIFICATION_GROUP_PERCENTAGE_COLUMN_PATH ||
    LINE_ITEMS_CHARGES_PERCENTAGE_PATTERN.test(fullPath) ||
    LINE_ITEMS_ALLOWANCES_PERCENTAGE_PATTERN.test(fullPath)
  );
};

const filterFieldsRecursively = (fields: Array<any>, parentPath?: string): Array<any> => {
  return fields
    .map((field) => {
      const fieldPath = field.path || '';
      const currentPath = parentPath ? `${parentPath}.${fieldPath}` : fieldPath;

      if (field.type === 'multi_column' && 'type_config' in field && field.type_config?.fields) {
        const filteredNestedFields = filterFieldsRecursively(field.type_config.fields, currentPath);

        if (filteredNestedFields.length === 0) {
          return null;
        }

        return {
          ...field,
          type_config: {
            ...field.type_config,
            fields: filteredNestedFields,
          },
        };
      }

      if (shouldRemoveField(currentPath)) {
        return null;
      }

      return field;
    })
    .filter((field) => field !== null);
};

export const useRemovePercentageColumn = (config: Array<any>) => {
  return useMemo(() => filterFieldsRecursively(config), [config]);
};
